import { PhoneDemo } from './phoneDemo';
import { useDemoStore } from './store';

export const DemoContainer = () => {
  const { showPhoneTriageDemo } = useDemoStore();

  return (
    <div className="absolute empty:hidden">
      {showPhoneTriageDemo && <PhoneDemo />}
    </div>
  );
};
